import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { ListItemIcon, Typography } from "@mui/material";
import { useState } from "react";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";
import type { MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import ChartOfAccounts from "../../chartOfAccounts/ChartOfAccounts.tsx";

interface Props {
  measure: MeasureField;
  onClose: () => void;
}

export default function ChartOfAccountsItem({ measure, onClose }: Props) {
  const [showCharOfAccounts, setShowCharOfAccounts] = useState(false);

  return (
    <>
      <PopoverMenuItem onClick={() => setShowCharOfAccounts(true)} sx={{ px: 2, py: 0.75, mb: 1 }}>
        <ListItemIcon sx={{ color: "secondary.main" }}>
          <AccountTreeOutlinedIcon />
        </ListItemIcon>
        <Typography>Chart of Accounts...</Typography>
      </PopoverMenuItem>
      {showCharOfAccounts && measure && (
        <ChartOfAccounts
          initialMeasure={measure.meta}
          onClose={() => {
            setShowCharOfAccounts(false);
            onClose();
          }}
        />
      )}
    </>
  );
}
